import { cn } from "lib/utils";
import styles from "./quiz-icons.module.css";

export const GrinningFace = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 120 120"
      className={cn(styles.icon, className)}
    >
      <path
        fill="currentColor"
        d="M5.176 63.439s1.81 15.449 15.016 22.071c13.207 6.623 26.118.23 37.98-1.29 6.213-.798 11.98 2.252 18.074 2.899 19.482 2.073 34.725-20.729 31.948-37.546-2.402-14.544-11.765-24.828-28.801-32.183-17.037-7.356-28.755-13.193-48.513-6.346C11.12 17.89 3.727 43.448 5.176 63.439"
        opacity="0.35"
      ></path>
      <path
        fill="#FFC22D"
        stroke="#263238"
        strokeMiterlimit="10"
        d="M82.82 99.142c17.319-7.44 25.326-27.512 17.886-44.831S73.193 28.984 55.875 36.425c-17.319 7.44-25.327 27.512-17.886 44.831 7.44 17.319 27.512 25.326 44.83 17.886Z"
      ></path>
      <mask
        id="a"
        width="70"
        height="70"
        x="34"
        y="33"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
      >
        <path
          fill="#FFC22D"
          stroke="#263238"
          strokeMiterlimit="10"
          d="M82.82 99.142c17.319-7.44 25.327-27.512 17.886-44.831-7.44-17.319-27.512-25.327-44.831-17.886-17.319 7.44-25.326 27.512-17.886 44.831s27.512 25.326 44.831 17.886Z"
        ></path>
      </mask>
      <g mask="url(#a)">
        <path
          fill="#000"
          d="M80.255 96.578A34.376 34.376 0 0 1 59.205 35 34.382 34.382 0 1 0 90 95.143a34.3 34.3 0 0 1-9.745 1.435"
          opacity="0.3"
        ></path>
      </g>
      <path
        fill="#263238"
        d="M88.434 55.236c0 2.619-.923 4.75-2.046 4.75s-2.057-2.131-2.057-4.75c0-2.618.923-4.75 2.057-4.75s2.046 2.132 2.046 4.75m-26.335 1.571c0 2.618-.912 4.75-2.047 4.75-1.134 0-2.046-2.132-2.046-4.75s.912-4.737 2.046-4.737c1.135 0 2.047 2.12 2.047 4.737M51.118 70.743s24.414-6.506 45.636-4.029c0 0 .756 20.887-20.77 23.202-18.653 2.008-24.866-19.173-24.866-19.173"
      ></path>
      <path
        fill="#B5B5B5"
        d="M82.195 87.431c-.618-4.86-6.361-8.292-13.013-7.702a14.35 14.35 0 0 0-8.947 3.913 20 20 0 0 0 15.94 5.083 28.7 28.7 0 0 0 6.02-1.294"
      ></path>
    </svg>
  );
};

export const SmilingFace = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 120 120"
      className={cn(styles.icon, className)}
    >
      <path
        fill="currentColor"
        d="M5.176 63.439s1.81 15.449 15.016 22.071c13.207 6.623 26.118.23 37.98-1.29 6.213-.798 11.98 2.252 18.074 2.899 19.482 2.073 34.725-20.729 31.948-37.546-2.402-14.544-11.765-24.828-28.801-32.183-17.037-7.356-28.755-13.193-48.513-6.346C11.12 17.89 3.727 43.448 5.176 63.439"
        opacity="0.35"
      ></path>
      <path
        fill="#FFC22D"
        stroke="#263238"
        strokeMiterlimit="10"
        d="M82.82 99.142c17.319-7.44 25.326-27.512 17.886-44.831S73.193 28.984 55.875 36.425c-17.319 7.44-25.327 27.512-17.886 44.831 7.44 17.319 27.512 25.326 44.83 17.886Z"
      ></path>
      <mask
        id="a"
        width="70"
        height="70"
        x="34"
        y="33"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
      >
        <path
          fill="#FFC22D"
          stroke="#263238"
          strokeMiterlimit="10"
          d="M82.82 99.142c17.319-7.44 25.327-27.512 17.886-44.831-7.44-17.319-27.512-25.327-44.831-17.886-17.319 7.44-25.326 27.512-17.886 44.831s27.512 25.326 44.831 17.886Z"
        ></path>
      </mask>
      <g mask="url(#a)">
        <path
          fill="#000"
          d="M80.255 96.578A34.376 34.376 0 0 1 59.205 35 34.382 34.382 0 1 0 90 95.143a34.3 34.3 0 0 1-9.745 1.435"
          opacity="0.3"
        ></path>
      </g>
      <path
        stroke="#263238"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M53.445 67.657s18.17 14.24 36.83 1.48"
      ></path>
      <path
        fill="#263238"
        d="M83.434 57.297c0 2.1-.83 3.81-1.84 3.81s-1.85-1.71-1.85-3.81.83-3.81 1.85-3.81 1.84 1.71 1.84 3.81m-17.68-.74c0 2.1-.82 3.81-1.84 3.81s-1.84-1.71-1.84-3.81.82-3.8 1.84-3.8 1.84 1.7 1.84 3.8"
      ></path>
    </svg>
  );
};

export const SadFace = ({ className }: { className?: string }) => {
  return (
    <svg
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(styles.icon, className)}
    >
      <path
        d="M5.587 63.132s1.81 15.448 15.016 22.071c13.206 6.623 26.118.23 37.979-1.29 6.213-.798 11.98 2.252 18.074 2.899 19.482 2.073 34.725-20.729 31.948-37.546-2.401-14.544-11.764-24.828-28.8-32.183C62.766 9.727 51.048 3.889 31.29 10.736 11.533 17.583 4.138 43.141 5.588 63.132Z"
        fill="#FFC22D"
      />
      <path
        opacity="0.7"
        d="M5.587 63.132s1.81 15.448 15.016 22.071c13.206 6.623 26.118.23 37.979-1.29 6.213-.798 11.98 2.252 18.074 2.899 19.482 2.073 34.725-20.729 31.948-37.546-2.401-14.544-11.764-24.828-28.8-32.183C62.766 9.727 51.048 3.889 31.29 10.736 11.533 17.583 4.138 43.141 5.588 63.132Z"
        fill="#fff"
      />
      <path
        d="M83.23 98.835c17.32-7.441 25.327-27.513 17.887-44.831-7.441-17.319-27.513-25.327-44.831-17.886-17.32 7.44-25.327 27.512-17.886 44.83 7.44 17.32 27.512 25.327 44.83 17.887Z"
        fill="#FFC22D"
        stroke="#263238"
        strokeMiterlimit="10"
      />
      <mask
        id="a"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="35"
        y="32"
        width="70"
        height="71"
      >
        <path
          d="M83.23 98.835c17.32-7.441 25.327-27.513 17.887-44.831-7.441-17.319-27.513-25.327-44.831-17.886-17.32 7.44-25.327 27.512-17.886 44.83 7.44 17.32 27.512 25.327 44.83 17.887Z"
          fill="#FFC22D"
          stroke="#263238"
          strokeMiterlimit="10"
        />
      </mask>
      <g mask="url(#a)">
        <path
          opacity="0.3"
          d="M80.666 96.27a34.376 34.376 0 0 1-21.05-61.577A34.381 34.381 0 1 0 90.41 94.836a34.259 34.259 0 0 1-9.745 1.435Z"
          fill="#000"
        />
      </g>
      <path
        d="M54.855 70.35s8.478 0 36.83 1.48"
        stroke="#263238"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M83.845 56.99c0 2.1-.83 3.81-1.84 3.81-1.01 0-1.85-1.71-1.85-3.81s.83-3.81 1.85-3.81 1.84 1.71 1.84 3.81ZM66.165 56.25c0 2.1-.82 3.81-1.84 3.81s-1.84-1.71-1.84-3.81.82-3.8 1.84-3.8 1.84 1.7 1.84 3.8Z"
        fill="#263238"
      />
    </svg>
  );
};
